var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnNavCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2.25C3.48122 2.25 2.25 3.48122 2.25 5V8C2.25 9.51878 3.48122 10.75 5 10.75H8C9.51878 10.75 10.75 9.51878 10.75 8V5C10.75 3.48122 9.51878 2.25 8 2.25H5ZM3.75 5C3.75 4.30964 4.30964 3.75 5 3.75H8C8.69036 3.75 9.25 4.30964 9.25 5V8C9.25 8.69036 8.69036 9.25 8 9.25H5C4.30964 9.25 3.75 8.69036 3.75 8V5Z",
    fill: "#001412"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 13.25C3.48122 13.25 2.25 14.4812 2.25 16V19C2.25 20.5188 3.48122 21.75 5 21.75H8C9.51878 21.75 10.75 20.5188 10.75 19V16C10.75 14.4812 9.51878 13.25 8 13.25H5ZM3.75 16C3.75 15.3096 4.30964 14.75 5 14.75H8C8.69036 14.75 9.25 15.3096 9.25 16V19C9.25 19.6904 8.69036 20.25 8 20.25H5C4.30964 20.25 3.75 19.6904 3.75 19V16Z",
    fill: "#001412"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 16C13.25 14.4812 14.4812 13.25 16 13.25H19C20.5188 13.25 21.75 14.4812 21.75 16V19C21.75 20.5188 20.5188 21.75 19 21.75H16C14.4812 21.75 13.25 20.5188 13.25 19V16ZM16 14.75C15.3096 14.75 14.75 15.3096 14.75 16V19C14.75 19.6904 15.3096 20.25 16 20.25H19C19.6904 20.25 20.25 19.6904 20.25 19V16C20.25 15.3096 19.6904 14.75 19 14.75H16Z",
    fill: "#001412"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2.25C14.4812 2.25 13.25 3.48122 13.25 5V8C13.25 9.51878 14.4812 10.75 16 10.75H19C20.5188 10.75 21.75 9.51878 21.75 8V5C21.75 3.48122 20.5188 2.25 19 2.25H16ZM14.75 5C14.75 4.30964 15.3096 3.75 16 3.75H19C19.6904 3.75 20.25 4.30964 20.25 5V8C20.25 8.69036 19.6904 9.25 19 9.25H16C15.3096 9.25 14.75 8.69036 14.75 8V5Z",
    fill: "#001412"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnNavCategory);
export default __webpack_public_path__ + "static/media/icn_nav_category.c04fe4812e98de3c136bda7194ea234d.svg";
export { ForwardRef as ReactComponent };